<template>
    <div v-if="additionals">
        <div v-if="additionals.salaVacinacaoLogada && !!additionals.salaVacinacaoLogada.id">
            <rkm-row>
                <rkm-col cols="12">
                    <rkm-table
                        :busy="busy"
                        :fields="fields"
                        :filter="filter"
                        :items="filteredItems"
                        ref="RkmTable"
                    >
                        <template v-slot:filters>
                            <rkm-row>
                                <rkm-col cols="12">
                                    <rkm-form-input
                                        label="Buscar"
                                        placeholder="Digite para buscar"
                                        v-model="filter"
                                    />
                                </rkm-col>
                            </rkm-row>

                            <rkm-row>
                                <rkm-col>
                                    <rkm-form-select
                                        :options="form.temposEspera"
                                        default-option-text="Todos"
                                        label="Tempo de espera"
                                        show-default-option
                                        text-field="minutos"
                                        v-model="model.tempoEsperaId"
                                        value-field="id"
                                    />
                                </rkm-col>

                                <rkm-col>
                                    <rkm-form-select
                                        :options="form.opcoesEntrada"
                                        default-option-text="Todas"
                                        label="Opção de entrada"
                                        show-default-option
                                        text-field="nome"
                                        v-model="model.opcaoEntradaId"
                                        value-field="id"
                                    />
                                </rkm-col>

                                <rkm-col>
                                    <rkm-form-select
                                        :options="form.prioridades"
                                        default-option-text="Todas"
                                        label="Prioridade"
                                        show-default-option
                                        text-field="nome"
                                        v-model="model.prioridadeId"
                                        value-field="id"
                                    />
                                </rkm-col>

                                <rkm-col>
                                    <rkm-form-select
                                        :options="form.status"
                                        default-option-text="Todos"
                                        label="Status"
                                        show-default-option
                                        text-field="nome"
                                        v-model="model.statusId"
                                        value-field="id"
                                    />
                                </rkm-col>
                            </rkm-row>
                        </template>

                        <template v-slot:cell(tempoEspera)="{item}">
                            <rkm-icon
                                v-if="item.tempoEspera.id"
                                :id="uniqueId('tempo-espera-tooltip')"
                                :style="'color: ' + item.tempoEspera.cor"
                                :title="formatTempoEspera(item.tempoEspera.total)"
                                font-scale="2"
                                icon="battery-full"
                                v-rkm-tooltip.hover
                            />

                            <span v-else>
                                -
                            </span>
                        </template>

                        <template v-slot:cell(actions)="{item}">
                            <template v-if="form.telas.length > 0">
                                <rkm-dropdown
                                    v-if="form.telas.length > 1"
                                    :color="item.chamadas > 0 ? 'secondary' : 'info'"
                                    class="mr-2"
                                    small
                                    title="Chamar"
                                    v-rkm-tooltip.hover
                                >
                                    <template v-slot:button-content>
                                        <rkm-icon icon="volume-up" />

                                        <rkm-badge v-if="item.chamadas > 0">
                                            {{ item.chamadas }}
                                        </rkm-badge>
                                    </template>

                                    <rkm-dropdown-item
                                        v-for="tela in form.telas"
                                        @click="call(item.id, tela.id)"
                                        v-bind:key="tela.id"
                                    >
                                        {{tela.nome}}
                                    </rkm-dropdown-item>
                                </rkm-dropdown>

                                <rkm-button
                                    v-else
                                    :color="item.chamadas > 0 ? 'secondary' : 'info'"
                                    @click="call(item.id, form.telas[0].id)"
                                    small
                                    title="Chamar"
                                >
                                    <rkm-icon icon="volume-up" />

                                    <rkm-badge v-if="item.chamadas > 0">
                                        {{item.chamadas}}
                                    </rkm-badge>
                                </rkm-button>
                            </template>

                            <rkm-button
                                @click="atender(item)"
                                authorize="store-imunizacao-registro-vacinacao"
                                color="primary"
                                small
                                title="Atender"
                            >
                                <rkm-icon icon="plus" />
                            </rkm-button>

                            <rkm-button
                                :disabled="!item.pacienteId"
                                @click="$refs.ModalRecepcao.open(item.id)"
                                authorize="update-imunizacao-fila-atendimento"
                                color="primary"
                                small
                                title="Editar"
                            >
                                <rkm-icon icon="pen" />
                            </rkm-button>

                            <rkm-button
                                @click="$refs.ModalEncaminhamento.open(item)"
                                color="primary"
                                small
                                title="Encaminhar atendimento"
                            >
                                <rkm-icon icon="location-arrow" />
                            </rkm-button>

                            <rkm-button
                                @click="$refs.ModalEvasao.open(item.id)"
                                color="danger"
                                small
                                title="Evadir"
                            >
                                <rkm-icon icon="running" />
                            </rkm-button>
                        </template>
                    </rkm-table>
                </rkm-col>
            </rkm-row>

            <ModalRecepcao ref="ModalRecepcao" />

            <ModalChamada
                :salas="form.salas"
                ref="ModalChamada"
            />

            <ModalEncaminhamento ref="ModalEncaminhamento" />
            <ModalEvasao ref="ModalEvasao" />
        </div>

        <rkm-alert v-else color="warning">
            A unidade logada não é uma sala de vacinação, favor cadastrá-la para efetuar um registro de vacinação.
        </rkm-alert>
    </div>
</template>

<script>
// Components.
import ModalChamada from './components/chamada/Modal'
import ModalEvasao from './components/evasao/Modal'
import ModalRecepcao from './components/recepcao/Modal'
import ModalEncaminhamento from './components/encaminhamento/Modal'

// Enums.
import modulo from '@/enums/administracao/modulo'

// Mixins.
import {error, repository, stringCase, websocket} from '@/mixins'

// Vuex.
import {mapActions, mapGetters} from 'vuex'

export default {
    components: {
        ModalChamada,
        ModalEvasao,
        ModalRecepcao,
        ModalEncaminhamento,
    },
    computed: {
        ...mapGetters({
            centroCusto: 'getCentroCusto',
            customer: 'getCustomer',
        }),
        filteredItems() {
            let fila = this.model.fila

            if (this.model.tempoEsperaId) {
                fila = fila.filter(item => item.tempoEspera.id === this.model.tempoEsperaId)
            }

            if (this.model.opcaoEntradaId) {
                fila = fila.filter(item => item.opcaoEntradaId === this.model.opcaoEntradaId)
            }

            if (this.model.prioridadeId) {
                fila = fila.filter(item => item.prioridadeId === this.model.prioridadeId)
            }

            if (this.model.statusId) {
                fila = fila.filter(item => item.statusId === this.model.statusId)
            }

            return fila
        },
    },
    created() {
        this.repositories = {
            chamada: this.getConectaSusRepository('imunizacao.chamada'),
            filaAtendimento: this.getConectaSusRepository('imunizacao.filaAtendimento'),
        }
    },
    data: () => ({
        additionals: null,
        busy: false,
        enums: {modulo},
        fields: [
            {key: 'tempoEspera', label: 'Tempo de espera'},
            {key: 'opcaoEntradaNome', label: 'Opção de entrada'},
            {key: 'senha', label: 'Senha'},
            {key: 'prioridadeNome', label: 'Prioridade'},
            {key: 'horarioChegada', label: 'Horário de chegada'},
            {key: 'pacienteNome', label: 'Nome'},
            {key: 'pacienteIdade', label: 'Idade'},
            {key: 'pacienteProntuario', label: 'Prontuário'},
            {class: 'col-min text-center', key: 'actions', label: 'Ações'},
        ],
        filter: null,
        form: null,
        model: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        init() {
            this.pusher.subscribe(`private-${this.customer.link}-painel-senha-fila`)
                .bind(`${this.centroCusto.setor.tipoId}.${this.centroCusto.id}.${this.enums.modulo.IMUNIZACAO}.updated`, (data) => {
                    this.model.fila = Object.assign(this.snakeObjectKeysToCamelRecursive(data.fila))
                })
        },
        load() {
            this.setLoading()

            this.repositories.filaAtendimento.list()
                .then(response => {
                    this.additionals = Object.assign(response.data.additionals)
                    this.form = Object.assign(response.data.form)
                    this.model = Object.assign(response.data.model)

                    this.$emit('additionals', this.additionals)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        call(filaId, telaId) {
            const request = {
                filaId: filaId,
                telaId: telaId,
            }

            if (this.form.salas.length > 0) {
                this.$refs.ModalChamada.open(filaId, telaId)
            } else {
                this.busy = true

                this.repositories.chamada.store(this.camelObjectKeysToSnakeRecursive(request))
                    .catch(this.handleError)
                    .finally(() => this.busy = false)
            }
        },
        atender(item) {
            if (item.pacienteId) {
                this.$router.push({name: 'imunizacao-registro-vacinacao-create', params: {id: item.pacienteId, filaId: item.id}})
            } else {
                this.$refs.ModalRecepcao.open(item.id, true)
            }
        },
        destroy(filaId) {
            const destroy = () => this.repositories.fila.destroy(filaId)

            this.showDeleteConfirmation('Deseja realmente excluir a senha?', destroy)
        },
        formatTempoEspera(value) {
            let format = 'Esperando por'

            if (value.dias !== null) {
                format = `${format} ${value.dias} dia(s)`
            }

            if (value.horas !== null) {
                format = `${format} ${value.horas} hora(s)`
            }

            if (value.minutos !== null) {
                if (value.horas !== null) {
                    format = `${format} e ${value.minutos} minuto(s)`
                } else {
                    format = `${format} ${value.minutos} minuto(s)`
                }
            }

            return format
        },
    },
    mixins: [error, repository, stringCase, websocket],
    mounted() {
        this.init()
        this.load()
    },
}
</script>